// VM 화면의 조작 칩 — 제목 옆 종류 칩(`PageHead` 의 kind)과 같은 크기·글꼴의 작은 칩이다.
// 사용자 화면과 관리자 화면이 같은 모양을 쓰므로 문자열은 여기 한 곳에만 있다.
// 손가락은 마우스보다 굵다 — 좁은 화면에서만 칩이 커진다. 넓은 화면의 치수는 그대로다.
export const TOUCH = 'max-sm:inline-flex max-sm:items-center max-sm:px-2.5 max-sm:py-1.5 max-sm:text-[11px]'
export const ACTION = `rounded border px-1.5 py-px text-[10px] tracking-[0.08em] uppercase disabled:opacity-50 ${TOUCH}`
export const ACTION_PLAIN = 'border-border text-muted-foreground hover:border-foreground/40 hover:text-foreground'
export const ACTION_DANGER = 'border-danger/35 text-danger-ink hover:border-danger/60 hover:bg-danger/8'

// 승인된 변경을 안고 있는 재부팅 칩(B-29). 브랜드 색으로 조용히 맥동해 누를 것이 생겼음을 말한다.
export const ACTION_WAITING = 'border-brand/50 text-brand-hover bg-brand/8 animate-pulse hover:bg-brand/15'

// 두 벌을 이어 쓰는 흔한 조합.
export const CHIP = `${ACTION} ${ACTION_PLAIN}`

// VM 에 붙인 태그(F-95) 한 낱말. 누르는 칩이 아니라 값이라 같은 크기의 테두리만 갖는다 — 목록과 상세가 같은 모양을 쓴다.
export const TAG = 'inline-block rounded border border-border px-1.5 py-px text-[10px] text-muted-foreground'
